import { z } from 'zod/v4';

export const AdminUpdateWebshopParamsSchema = z.object({
  id: z.string().min(1),
});

export type AdminUpdateWebshopParams = z.infer<
  typeof AdminUpdateWebshopParamsSchema
>;

// Every field is optional and an explicit `null` is not the same as leaving a
// field out: absent keeps the stored value, `null` clears it. `newId` renames
// the shop (`id` stays the URL segment); like a create id it cannot hold a
// slash. `connectedOrigins` is an array of allowed-origin ids here, even though
// the row stores them comma-separated.
export const AdminUpdateWebshopBodySchema = z.object({
  newId: z
    .string()
    .min(1)
    .max(255)
    .regex(/^(?!.*\/.*$)/)
    .nullish(),
  name: z.string().min(1).max(255).nullish(),
  isBlocked: z.number().nullish(),
  companyId: z.string().min(1).max(255).nullish(),
  shopPlatform: z.string().min(1).max(255).nullish(),
  connectedOrigins: z.array(z.string().min(1).max(36)).nullish(),
});

export type AdminUpdateWebshopBody = z.infer<
  typeof AdminUpdateWebshopBodySchema
>;
